import axios from "../axiosInstance";
import {
  SendBatchProspectsToFtpRequest,
  SendBatchProspectsToFtpResponse,
} from "./types";

export const sendBatchProspectsToFtp = async (
  requestData: SendBatchProspectsToFtpRequest,
): Promise<SendBatchProspectsToFtpResponse> => {
  const response = await axios.post<SendBatchProspectsToFtpResponse>(
    `/api/private/clientdata/export`,
    requestData,
  );
  return response.data;
};
